/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { DragulaModule } from 'ng2-dragula';
import { DragulaContextDirective } from './dragula-context.directive';

@NgModule({
  imports: [DragulaModule],
  declarations: [DragulaContextDirective],
  exports: [DragulaModule, DragulaContextDirective],
})
export class CoreUiDragulaModule {
}
